












































import { Component, Vue, Ref } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { ActionsPayload, ActionsKeys } from '@/store/types';

@Component({})
export default class LoginForm extends Vue {
  @Ref('loginForm') loginForm!: Vue;
  @Action(ActionsKeys.SET_CURRENT_USER) setCurrentUser!: (payload: ActionsPayload['SET_CURRENT_USER']) => void;

  validLoginForm = true;
  loggedIn = false;
  error = false;

  registerData = {
    email: '',
    password: '',
  };

  registerDataValidations = {
    email: [(v: string) => !!v || 'E-mail is required', (v: string) => /.+@.+\..+/.test(v) || 'E-mail must be valid'],
    password: [(v: string) => !!v || 'Password is required'],
  };

  async submitRegister() {
    /* eslint-disable @typescript-eslint/camelcase */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((this.loginForm as any).validate()) {
      // TODO: Move to action, set axios
      try {
        const res = await fetch(`${process.env.VUE_APP_API_URL}/auth/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: this.registerData.email,
            password: this.registerData.password,
          }),
        });
        if (res.status === 200) {
          this.loggedIn = true;
          const { user, token: jwt } = await res.json();
          this.setCurrentUser({
            user: { ...user },
            jwt,
          });
        } else {
          this.error = true;
        }
      } catch (e) {
        console.warn(e);
      }
    }
    /* eslint-enable @typescript-eslint/camelcase */
  }
}
